import { call, put, takeLatest } from 'redux-saga/effects';
import { OP } from "../../constant";
import { doAddAgentStaff, doFetchAgentStaff, doViewAgentStaff, doEditAgentStaff, doDeactivateAgentStaff, doApproveAgentStaff, doRejectAgentStaff, doActivateAgentStaff, doUnblockAgent, doResetAgentPassword } from '../../service/agentStaff'

import errorMessage from "../../utils/error.json";

/* ------------------------- AGENT_STAFF SAGA --------------------- */
// fetch agent list
function* fetchAgentStaffTask(action) {
    try {
        yield put({ type: OP.AGENT_STAFF_LIST_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doFetchAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.AGENT_STAFF_LIST_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.AGENT_STAFF_LIST_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.AGENT_STAFF_LIST_FAILURE,
            payload: errMsg
        })
    }
}

// add agent
function* addAgentStaffTask(action) {
    try {
        yield put({ type: OP.ADD_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doAddAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.ADD_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.ADD_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.ADD_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// view agent
function* viewAgentStaffTask(action) {
    try {
        yield put({ type: OP.VIEW_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doViewAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.VIEW_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.VIEW_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.VIEW_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// edit agent
function* editAgentStaffTask(action) {
    try {
        yield put({ type: OP.EDIT_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doEditAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.EDIT_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.EDIT_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.EDIT_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// activate agent
function* activateAgentStaffTask(action) {
    try {
        yield put({ type: OP.ACTIVATE_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doActivateAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.ACTIVATE_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.ACTIVATE_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.ACTIVATE_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// deactivate agent
function* deactivateAgentStaffTask(action) {
    try {
        yield put({ type: OP.DEACTIVATE_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doDeactivateAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.DEACTIVATE_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.DEACTIVATE_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.DEACTIVATE_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// approve agent
function* approveAgentStaffTask(action) {
    try {
        yield put({ type: OP.APPROVE_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doApproveAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.APPROVE_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.APPROVE_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.APPROVE_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// reject agent
function* rejectAgentStaffTask(action) {
    try {
        yield put({ type: OP.REJECT_AGENT_STAFF_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doRejectAgentStaff, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.REJECT_AGENT_STAFF_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.REJECT_AGENT_STAFF_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.REJECT_AGENT_STAFF_FAILURE,
            payload: errMsg
        })
    }
}

// reset agent password
function* resetAgentPasswordTask(action) {
    try {
        yield put({ type: OP.RESET_AGENT_PASSWORD_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doResetAgentPassword, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.RESET_AGENT_PASSWORD_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.RESET_AGENT_PASSWORD_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.RESET_AGENT_PASSWORD_FAILURE,
            payload: errMsg
        })
    }
}

// unblock agent
function* unblockAgentStaffTask(action) {
    try {
        yield put({ type: OP.UNBLOCK_AGENT_LOADING });

        const { payload } = action

        const { res, decoded_data } = yield call(doUnblockAgent, payload.token, payload.data);

        if (res.status == 200) {
            yield put({
                type: OP.UNBLOCK_AGENT_SUCCESS,
                payload: decoded_data.data //save all data to payload
            })

        } else {
            const errMsg = res.data ? errorMessage[res.data.code] : errorMessage[1000];
            yield put({
                type: OP.UNBLOCK_AGENT_FAILURE,
                payload: errMsg
            })
        }
    } catch (e) {
        const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
        yield put({
            type: OP.UNBLOCK_AGENT_FAILURE,
            payload: errMsg
        })
    }
}

function* agentStaffSaga() {
    yield takeLatest(OP.AGENT_STAFF_LIST_REQUEST, fetchAgentStaffTask);
    yield takeLatest(OP.ADD_AGENT_STAFF_REQUEST, addAgentStaffTask);
    yield takeLatest(OP.VIEW_AGENT_STAFF_REQUEST, viewAgentStaffTask);
    yield takeLatest(OP.EDIT_AGENT_STAFF_REQUEST, editAgentStaffTask);
    yield takeLatest(OP.ACTIVATE_AGENT_STAFF_REQUEST, activateAgentStaffTask);
    yield takeLatest(OP.DEACTIVATE_AGENT_STAFF_REQUEST, deactivateAgentStaffTask);
    yield takeLatest(OP.APPROVE_AGENT_STAFF_REQUEST, approveAgentStaffTask);
    yield takeLatest(OP.REJECT_AGENT_STAFF_REQUEST, rejectAgentStaffTask);
    yield takeLatest(OP.RESET_AGENT_PASSWORD_REQUEST, resetAgentPasswordTask);
    yield takeLatest(OP.UNBLOCK_AGENT_REQUEST, unblockAgentStaffTask);
}

export default agentStaffSaga;